import clsx from 'clsx';
import React, { useEffect } from 'react';
import AreaListForm from './AreaListForm';
import { useState } from 'react';
import { checkEmptyObject } from 'utils/functionality';
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import axios from 'axios';
import { useAppContext } from 'components/Context/AppContext';

const initialState = {
  date: '',
  pickup_location_name: '',
  dropoff_location_name: '',
  detail_pickup_location: '',
  detail_drop_off_location: '',
  detail_driving_location: '',
  booking_start_time: '',
  booking_end_time: '',
  charter_duration: 0,
  pickup_zone_lat: 0,
  pickup_zone_long: 0,
  drop_off_zone_lat: 0,
  drop_off_zone_long: 0,
  startLocation: undefined,
  endLocation: undefined,
  sameLocation: false,
};

const getBooundingBoxLocation = async (locationName, setStateBoundingBox, showToast) => {
  if (!locationName?.trim()) {
    setStateBoundingBox([]);
    return;
  }

  try {
    const { data } = await axios.get('https://photon.komoot.io/api/', {
      params: {
        q: locationName,
        limit: 1,
      },
      timeout: 10000,
    });

    const extent = data?.features?.[0]?.properties?.extent;

    if (!extent) {
      setStateBoundingBox([]);
      return;
    }

    const boundingBox = [extent[1], extent[3], extent[0], extent[2]];

    setStateBoundingBox(boundingBox);
  } catch (error) {
    setStateBoundingBox([]);
    showToast({
      type: 'error',
      message: error?.message || 'Failed to fetch location',
    });
  }
};

const AreaCharter = ({
  className,
  style,
  startDate,
  durationRentDate = 0,
  disable,
  forCustomOrder,
  rentalLocation,
  allAreaCharter = [],
  setAllAreaCharter,
  sameLocationCheck,
}) => {
  const { showToast } = useAppContext();

  const provider = new OpenStreetMapProvider();
  const [locationData, setLocationData] = useState({ latlng: [-8.2271303, 115.1919203], bounds: null });
  const [boundingBoxLocation, setBoundingBoxLocation] = useState([]);

  const searchFunc = async (input) => {
    const results = await provider
      .search({ query: input })
      .then((res) =>
        res?.length > 0
          ? setLocationData({ latlng: [res[0].y, res[0].x], bounds: res[0].bounds })
          : setLocationData({ latlng: [-8.2271303, 115.1919203], bounds: null }),
      )
      .catch(() => setLocationData({ latlng: [-8.2271303, 115.1919203], bounds: null }));
    return results;
  };

  useEffect(() => {
    if (!rentalLocation || checkEmptyObject(rentalLocation)) return;

    searchFunc(rentalLocation.name);
    getBooundingBoxLocation(rentalLocation.name, setBoundingBoxLocation, showToast);
  }, [rentalLocation]);

  useEffect(() => {
    if (!durationRentDate || !forCustomOrder || allAreaCharter?.length !== 0) return;

    const newArrayAllAreaCharter = [];

    for (let i = 0; i < durationRentDate; i++) {
      newArrayAllAreaCharter.push(initialState);
    }
    setAllAreaCharter(newArrayAllAreaCharter);
  }, [durationRentDate]);

  return (
    <div className={clsx('area-charter', className)} style={style}>
      {durationRentDate === 0 ? (
        <div className="area-charter__empty-data">Tidak ada Area Charter</div>
      ) : (
        <ul className="area-charter__form">
          {Array.from({ length: durationRentDate }).map((_, index) => (
            <AreaListForm
              key={index + 1}
              item={index + 1}
              index={index}
              disable={disable}
              areaCharterData={allAreaCharter[index]}
              allAreaCharter={allAreaCharter}
              setAllAreaCharter={setAllAreaCharter}
              startDate={startDate}
              forCustomOrder={forCustomOrder}
              rentalLocation={rentalLocation}
              locationData={locationData}
              boundingBoxLocation={boundingBoxLocation}
              sameLocationCheck={sameLocationCheck}
            />
          ))}
        </ul>
      )}
    </div>
  );
};

export default AreaCharter;
